<template>
    <div v-if="show">

        <v-btn class="primary" :class="datas.button.class" v-for="(sms,i) in listSms" :key="i" @click="SelectSms(sms)"><v-icon>mdi-message-text-outline</v-icon> {{ sms.titre }}</v-btn>

        <div v-for="(pending,p) in smsPending" :key="'s'+p">
            <div v-if="pending.group.includes(paramsSms.id)">
                {{ listSms[pending.selectedSms.id].titre }}
                <span v-if="moment(pending.planified).isBefore(moment())"> en cours d'envoi (restant : {{ pending.group.length }}/{{ pending.total }})</span>
                <span v-else>, {{ pending.total }} sms planifies le {{ moment(pending.planified).format('DD-MM-YYYY a HH:mm') }}</span>
                <v-btn x-small @click="annulSend(pending)">Annuler l'envoi</v-btn> -
                <v-btn x-small @click="annulSend(pending,true)">Annuler l'envoi groupe</v-btn>
            </div>
        </div>

        <v-dialog
        :retain-focus="false"
        width="50%"
        v-model="dialog"
        :fullscreen="$vuetify.breakpoint.xs">
        <OverLay/>
            <v-card>
                <v-card-title class="text-h5 grey lighten-2">
                    Envoi du SMS
                <v-spacer></v-spacer>
                <v-btn icon @click="closeDialog()"><v-icon>mdi-close-thick</v-icon></v-btn>
            </v-card-title>
            <v-card-text>
                <p class="text-center text-h6">Expediteur : {{ paramsSms.sender }}</p>

                <v-tabs v-model="tab">

                <v-tabs-slider></v-tabs-slider>

                <v-tab href="#indiv">Individuel</v-tab>
                <v-tab href="#group">envoi groupe</v-tab>

                <v-tabs-items v-model="tab" class="pa-2">

                <v-tab-item id="indiv" value="indiv" >
                <v-row>
                    <v-col>

                        <ArrayTable
                            :item="{otherparams:{
                                arrayTable:[
                                    {type:'',key:'Name',name:'alias'},
                                    {type:'',key:'Phone',name:'numero de telephone'}]}
                            ,defaultprops:{show:true,tableDraggable:false,tableDel:false,hideFooter:true,hidesearch:true,addTitle:'ajouter un numero'}}"
                            :valField="paramsSms.phones"
                            :change="(item,model)=> { changeParams(item,model,'phones') }"
                            />

                        <div v-if="fieldForUpdate">
                            <fromBDD
                            :item="{fromBDD:fieldForUpdate,defaultprops:{show:true}}"
                            :page="page"
                            :valField="paramsSms.selectedSms.corp"
                            :keyup="(item,model)=> { changeSms(item,model,'corp') }"
                            />
                        </div>
                        <div v-else>
                            <TextArea
                            :item="{ name: 'message', value: 'corp' ,defaultprops:{ show: true, autogrow: true, row: 5 }}"
                            :valField="paramsSms.selectedSms.corp"
                            :keyup="(item,model)=> { changeSms(item,model,'corp') }"
                            />
                        </div>

                    </v-col>

                    </v-row>
                    <v-row>
                        <v-col class="col-12 col-md-3">

                            <v-btn @click="send">envoyer</v-btn>

                        </v-col>
                    </v-row>
                    </v-tab-item>

                    <v-tab-item id="group" value="group">
                        <v-row>
                            <v-col>
                                <p>L'envoi groupe est personalise par le message que vous avez choisi.</p>
                                <p align="center"><b>{{ selectedGroup.length }} selection(s)</b></p>

                                <p>
                                    <SwitchC
                                    :item=" { name: 'Autoriser l\'envoi aux personnes qui sont en statut \'envoye\' ou \'en cours\'.',value: '',liste: [{ text: 'OUI', value: true },{ text: 'NON', value: false }],
                                        defaultprops:{ show: true, column: false }}"
                                    :change="(item,model) => { removeOrAllowAll = model;  }"
                                    :valField="removeOrAllowAll"
                                    />
                                </p>

                                <SimpleTable :key="reload" :Headers="listGroup.headers" :datas="listGroup.liste" :selected="selectedGroup" keyRow="id"
                                @getselected="(val) =>{ selectedGroup = val}" :hidefooter="true" />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col class="col-12 col-md-3">
                                <Radio
                                    :change="(item,value) => { isplann = value }"
                                    :valField="isplann"
                                    :item="{name:'Envoi ',value:'isplann',liste:[{text:'Maintenant',value:'now'},{text:'Planifier',value:'after'}],
                                    defaultprops:{show:true, column:false, class:'pa-0 ma-0' }}"
                                    />

                                <dateTimePicker
                                v-if="isplann == 'after' "
                                    :item="{ name: 'Planifier le', value: 'planified' ,defaultprops:{ show: true}}"
                                    :valField="paramsSms.planified"
                                    :change="(item,model)=> { paramsSms.planified = model }"
                                    />

                                <v-btn @click="sendgroup">envoyer</v-btn>
                            </v-col>
                        </v-row>
                    </v-tab-item>
                    </v-tabs-items>
                    </v-tabs>

                    </v-card-text>
                </v-card>

            </v-dialog>
        </div>
</template>



<script>
import fromBDD from '../../fields/fromBDD.vue';
import { client } from '../mixins';

export default {

    name: "sendSms",

    mixins : [client],

    components: {
        TextArea: () => import("@/components/fields/textarea.vue"),
        SwitchC: () => import("@/components/fields/switch.vue"),
        dateTimePicker: () => import("@/components/fields/dateTimePicker.vue"),
        ArrayTable: () => import("@/components/fields/arrayTable.vue"),
        OverLay: () => import('@/components/outils/overlay.vue'),
        SimpleTable: () => import("@/components/engine/outils/simpleTable.vue"),
        Radio    : () => import('@/components/fields/radio.vue'),
        fromBDD
    },

    data: function () {

        return {
            tab : '',
            AllowedDisplay: true,
            show: false,
            datas: {},
            isplann : 'now',
            paramsSms: { selectedSms : {}, phones : [], sender: '', send:false, planified : new Date() },
            querys: {},
            dialog: false,
            fieldForUpdate : false,
            listSms : [],
            listGroup : {liste:[],headers:[],'smswaiting':[],'smssent':[]},
            selectedGroup:[],
            smsPending : [],
            selWaiting : [],
            selSent : [],
            removeOrAllowAll : false,
            reload : 0,
            typePage : (!this.$store.getters['listForm'](this.modalKey)) ? 'page' : this.$store.getters['listForm'](this.modalKey).typeform,
        }
    },

    computed : {
            modEditForm() {
                return this.$store.getters['listForm'](this.modalKey);
            }
    },

    watch: {

        'modEditForm.typeform': {
                handler(newVal,oldVal) {
                    if(oldVal!='new') return;
                        this.typePage = newVal
                        this.initiateParams()
                        this.callAPI()
                },deep:true,
            },

            dialog(val) {
                if(val) this.reload++;
            },

            removeOrAllowAll(val) {
                if(val) {
                    this.listGroup.liste.forEach((v,i) => {
                    this.listGroup.liste[i]['isSelectable'] = true;
                    })
                } else {
                    this.listGroup.liste.forEach((v,i) => {
                    var isSelectable = true;
                    if(this.selWaiting.includes(v.id) || this.selSent.includes(v.id)) {
                        isSelectable = false;
                        this.selectedGroup = this.selectedGroup.filter(num => num !== v.id);
                    }
                    this.listGroup.liste[i]['isSelectable'] = isSelectable;
                    })
                }
            this.reload++
            }
    },

    methods: {

        callAPI: function () {
            if(this.typePage=='new') return
            this.API({ type: 'post', url: 'displaymodule', params: { id: this.idmodule, params: this.paramsSms, querys: this.querys } }).then((resp) => {
                this.manageDatas(resp.data)
            })

        },

        manageDatas(data) {
            this.datas = data;
                if (!data.success) {
                    this.AllowedDisplay = false;
                    this.$toast.error(data.message)
                    return false;
                }
                this.listSms = data.listsms;

                    this.paramsSms.phones = data.phones
                    this.paramsSms.sender = data.sender
                    this.smsPending = data.smspending;
                    if(data.group) this.listGroup = data.group
                    if(data.idField) this.fieldForUpdate = data.idField


                this.show = true
                if(this.querys.selected && this.listSms[this.querys.selected]) {

                    this.SelectSms(this.listSms[this.querys.selected]);
                }
        },

        changeParams(item, value, type) {
            this.paramsSms[type] = value
        },

        changeSms(item, value, type) {
            this.paramsSms.selectedSms[type] = value
        },

        send() {

            this.$store.dispatch('textOverlay','Envoi du sms en cours');
            this.$store.dispatch('getoverlay', true)
            this.paramsSms.send = true
            this.API({ type: 'post', url: 'displaymodule', params: { id: this.idmodule, params: this.paramsSms, querys: this.querys } }).then((resp) => {
                this.$store.dispatch('getoverlay', false)

                if (!resp.data.success) {
                    this.$toast.error(resp.data.message)
                    return false;
                }
                this.$toast.success("le sms est bien envoye !")
                this.dialog = false;
                })
        },


        sendgroup() {
            if(this.selectedGroup.length==0) {
                this.$toast.info('Veuillez selectionner au moins une ligne')
                return false;
            }
            if(this.isplann=='after' && this.moment() > this.moment(this.paramsSms.planified)) {
                this.$toast.info("La date d'envoi doit etre superieure a la date courante");
                return false;
            }

            if(confirm('Vous allez programmer '+this.selectedGroup.length+' sms, confirmer cette action ?')) {
            this.$store.dispatch('textOverlay',"Preparation de l'envoi groupe");
            this.$store.dispatch('getoverlay', true)

            this.API({ type: 'post', url: 'displaymodule', params: { group : this.selectedGroup, id: this.idmodule, params: this.paramsSms, querys: this.querys }}).then((resp) => {
                this.$store.dispatch('getoverlay', false)

                if (!resp.data.success) {
                    this.$toast.error(resp.data.message)
                    return false;
                } else {
                    this.$toast.success(resp.data.message)
                }
                this.dialog = false;
                this.selectedGroup = []
                this.callAPI();

                })
            }

        },

        annulSend(sms,group) {
            this.$store.dispatch('textOverlay',"Suppression de l'envoi");
            this.$store.dispatch('getoverlay', true)
            this.API({ type: 'post', url: 'displaymodule', params: { annulsend : sms.key, idannul : this.paramsSms.id ,allcampaign : group, id: this.idmodule, params: this.paramsSms}}).then((resp) => {
                this.$store.dispatch('getoverlay', false)

                if (!resp.data.success) {
                    this.$toast.error(resp.data.message)
                } else {
                    this.$toast.success(resp.data.message)
                }
                this.callAPI();
                this.$store.dispatch('getoverlay', false)
                })
        },


        initiateParams() {

        const params = this.resolveModuleParams()
        this.paramsSms = {...this.paramsSms, ...params}

        this.querys = this.$store.getters.specificPage(this.modalKey).querys

        if (this.hook == 'search') this.querys.global = this.$store.getters.getStringSearch;
        },

        SelectSms(sms) {

            this.paramsSms.selectedSms = sms
            if(this.listGroup.smswaiting[ sms.id ]) this.selWaiting = this.listGroup.smswaiting[ sms.id ]
            if(this.listGroup.smssent[ sms.id ]) this.selSent = this.listGroup.smssent[ sms.id ]
            this.listGroup.liste.forEach((v,i) => {
                var isSelectable = true;
                if(this.selWaiting.includes(v.id)) { this.listGroup.liste[i]['etat'] = 'en cours, '; isSelectable = false; }
                if(this.selSent.includes(v.id)) { this.listGroup.liste[i]['etat'] += 'envoye'; isSelectable = false; }
                this.listGroup.liste[i]['isSelectable'] = isSelectable;
            })
            this.dialog = true
        },

        closeDialog() {
            this.dialog = false
            this.paramsSms.selectedSms = {}
            this.selWaiting = []
            this.selSent = []
            this.selectedGroup = []
            this.removeOrAllowAll = false
            this.listGroup.liste.forEach((v,i) => {
                this.listGroup.liste[i]['etat'] = '';
                this.listGroup.liste[i]['isSelectable'] = true;
            })
        },

    },
    mounted() {
        this.initiateParams()

        if(this.typePage=='new') return

        let getdatas = this.$store.getters.getModuleDatas({page:this.modalKey,id:this.idmodule});
                if(getdatas) {
                    this.manageDatas(getdatas.datas)
                    this.$store.dispatch('removeModuleDatas',{page:this.modalKey,id:this.idmodule})
                } else {
                    this.callAPI()
                }


    },

    created() {

    }

}

</script>
